export default __webpack_public_path__ + "static/media/Logo_EssilorLuxottica.75f84d91.svg";